var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0543 10.0007L8.36177 15.631C8.3149 15.6764 8.27785 15.7303 8.25276 15.7895C8.22766 15.8488 8.21502 15.9122 8.21558 15.9762C8.21613 16.0402 8.22986 16.1034 8.25597 16.1623C8.28208 16.2211 8.32006 16.2744 8.36771 16.319C8.41535 16.3636 8.47171 16.3987 8.53354 16.4222C8.59536 16.4457 8.66142 16.4572 8.72788 16.456C8.79435 16.4547 8.8599 16.4409 8.92075 16.4151C8.9816 16.3893 9.03653 16.3522 9.08238 16.3059L15.1154 10.3381C15.2067 10.2477 15.2578 10.1267 15.2578 10.0007C15.2578 9.87462 15.2067 9.75357 15.1154 9.66323L9.08238 3.69543C9.03653 3.6491 8.9816 3.61198 8.92075 3.58622C8.8599 3.56045 8.79435 3.54656 8.72788 3.54534C8.66142 3.54413 8.59536 3.55561 8.53354 3.57912C8.47171 3.60263 8.41535 3.63771 8.36771 3.68233C8.32006 3.72695 8.28208 3.78022 8.25597 3.83906C8.22986 3.8979 8.21613 3.96113 8.21558 4.02511C8.21502 4.08909 8.22766 4.15254 8.25275 4.21179C8.27785 4.27103 8.3149 4.3249 8.36177 4.37028L14.0543 10.0007Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackRightArrow);
export default __webpack_public_path__ + "static/media/blackRightArrow.715c30f4fcf03e7f72a9f9b3ec931f61.svg";
export { ForwardRef as ReactComponent };